import React from 'react';
import { formatEnumValue } from 'formatters';
import { Chip, Typography } from '@mui/material';
import { ChipOwnProps } from '@mui/material/Chip/Chip';

import { ChangeType } from '../../../../api';

const CHANGE_TYPE_COLOR_MAP: Record<ChangeType, ChipOwnProps['color']> = {
  AVAILABILITY: 'info',
  DEALER_LIST: 'secondary',
  PRICING_MARKUP: 'warning',
  PRODUCT_CONFIG: 'primary',
  INITIAL_CREATION: 'success',
  PRODUCT_CATALOG_DOCUMENTS: 'default',
};

interface ChangeTypeChipProps {
  changeType: ChangeType;
}

export const ChangeTypeChip = ({ changeType }: ChangeTypeChipProps) => {
  const color = CHANGE_TYPE_COLOR_MAP[changeType] ?? 'default';

  return (
    <Chip size="medium" label={<Typography>{formatEnumValue(changeType)}</Typography>} color={color} variant="filled" />
  );
};
